import {
  EMPTY_SEARCH_USERS_RESPONSE,
  USER_SEARCH_QUERY_KEY,
} from "@frontend-shared/constants";
import type {
  ISearchUsersParams,
  IUseSearchUsersResult,
} from "@frontend-shared/types";
import { useQuery } from "@tanstack/react-query";

import { userApi } from "@/api/services";

export const useSearchUsers = ({
  query,
  limit,
  enabled: enabledOverride,
}: ISearchUsersParams): IUseSearchUsersResult => {
  // NOTE: ?? has lower precedence than >, so this evaluates as: enabledOverride ?? (query.trim().length > 0)
  const isEnabled = enabledOverride ?? query.trim().length > 0;
  const { data = EMPTY_SEARCH_USERS_RESPONSE, isLoading } = useQuery({
    queryKey: [USER_SEARCH_QUERY_KEY, query, limit],
    queryFn: () => userApi.searchUsers({ query, limit }),
    enabled: isEnabled,
  });

  return { data, isLoading };
};
